let i = 0;

const EVENTS = {
	APP_LOADED: i++,

	ATTACH: i++,
	DETACH: i++,
	RESIZE: i++,

	TICK: i++,
	RENDER: i++,
	BEFORE_TICK: i++,
	AFTER_RENDER: i++,

	POINTER_MOVE: i++,
	DEVICE_ACCELERATION: i++,
};

const LAYERS = {
	OUTSCREEN: 0,
	INSCREEN: 1,
	SCREEN: 2,
};

const COLORS = {
	BLUE: 'vec3(0.176, 0.227, 0.945)',
};

const DEVICE = {
	MOTION: false,
	BREAKPOINT: 1025,
};

export { COLORS, EVENTS, LAYERS, DEVICE };
